import { useMutation } from '@tanstack/react-query';
import { useFetcher } from '../../graphql';
import { CallTokenResult } from './useStartCall';

/**
 * Accept or decline a ringing call. On accept, resolves with the callee's
 * LiveKit token so they can join the room; on decline, `token` is null.
 */
export const useRespondToCall = () => {
  const fetcherFn = useFetcher<
    { call: { respondToCall: CallTokenResult } },
    { input: { callId: string; accept: boolean } }
  >(RESPOND_TO_CALL);

  return useMutation({
    mutationFn: async (args: {
      callId: string;
      accept: boolean;
    }): Promise<CallTokenResult> => {
      const data = await fetcherFn({ input: args });
      return data.call.respondToCall;
    },
  });
};

const RESPOND_TO_CALL = `
  mutation RESPOND_TO_CALL($input: RespondToCallInput!) {
    call {
      respondToCall(input: $input) {
        call {
          id
          room
          state
          caller { id }
          callee { id }
        }
        token
        url
      }
    }
  }
`;
